import React, { Component } from 'react'
import Header from '../Header'
import './VIs.css'

class VIs extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyVIs">
                    <p className="textVI">1916 - Jeux attribués à Berlin, Allemagne. Annulés à cause de la Première Guerre mondiale.</p>
                </div>
            </div>
        )
    }
}

export default VIs